import { render, staticRenderFns } from "./IconGlm.vue?vue&type=template&id=b2663006&scoped=true"
var script = {}
import style0 from "./IconGlm.vue?vue&type=style&index=0&id=b2663006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2663006",
  null
  
)

export default component.exports